<template>
  <Layout>
    <PageHead :pageHeadData="PageHeadData" HeadType="FCST" />
    <ProductOverview :summarizeText="SummarizeText" :videoData="videoData" />
    <!-- 业务蓝图 -->
    <section
      class="rn-section-gap slider-bg-image"
      :style="{
        'background-image': `url(${require('@/assets/images/ProductService/VyungFCST/business-blueprint_bg.png')})`,
      }"
    >
      <SectionTitle
        :title="$t('product.business_blueprint')"
        description="BUSINESS BLUEPRINT"
        textAlign="center"
      />
      <div class="container">
        <FCSTBusinessBlueprint></FCSTBusinessBlueprint>
      </div>
    </section>

    <ProductAbility :abilityData="AbilityData" abilityType="FCST" />
    <ProductSuperiority :productSuperiorityData="ProductSuperiorityData" />
    <ClassicCases
    :classicCasesData="ClassicCasesData" />
  </Layout>
</template>

<script>
import Layout from "../../components/common/Layout";
import Icon from "../../components/icon/Icon";
import Separator from "../../components/elements/separator/Separator";
import SectionTitle from "../../components/elements/sectionTitle/SectionTitle";
import ProductOverview from "./components/ProductOverview.vue";
import ProductAbility from "./components/ProductAbility.vue";
import PageHead from "./components/PageHead.vue";
import ProductSuperiority from "./components/ProductSuperiority/ProductSuperiority.vue";
import ClassicCases from '../IndustrySolution/components/ClassicCases.vue'
import FCSTBusinessBlueprint from "./components/BusinessBlueprint/FCSTBusinessBlueprint.vue";
import {
  FCST_icon01,
  FCST_icon02,
  numImage01,
  numImage02,
  numImage03,
  zhongtongBackground,
  HITACHIBackground,
  YTOBackground,
  JOHNIcon,
  TCLIcon,
  PRINXIcon,
  FCSTAbility01,
  FCSTAbility02,
  FCSTAbility03,
  FCSTAbility04,
} from "./Image.js";

export default {
  name: "VyungFCST",
  components: {
    Icon,
    Layout,
    Separator,
    SectionTitle,
    ProductOverview,
    ProductAbility,
    PageHead,
    ProductSuperiority,
    ClassicCases,
    FCSTBusinessBlueprint,
  },
  data() {
    return {
      //页面头部
      PageHeadData: {
        engTitle: "Forecast",
        text01: this.$t("product.VyungFCST.head.text01"),
        text02: this.$t("product.VyungFCST.head.text02"),
        subtitle: this.$t("product.VyungFCST.head.subtitle"),
        image: require("@/assets/images/ProductService/VyungFCST/FCST-Image.png"),
      },
      //产品概述
      videoData: [
        {
          src:process.env.VUE_APP_VIDEO_URL+'/$web/video/product_fcst.mp4?'+process.env.VUE_APP_VIDEO_RAXWDL,
          thumb: require(`@/assets/images/ProductService/VyungFCST/fcst_video_thumb.jpg`)
        },
      ],
      SummarizeText: this.$t("product.VyungFCST.product_overview.text"),

      //业务蓝图

      //产品功能
      AbilityData: [
        {
          title: this.$t("product.VyungFCST.product_ability.card01.title"),
          text: [
            {
              subtitle: this.$t(
                "product.VyungFCST.product_ability.card01.text[0].subtitle"
              ),
              subtext: this.$t(
                "product.VyungFCST.product_ability.card01.text[0].subtext"
              ),
            },
            {
              subtitle: this.$t(
                "product.VyungFCST.product_ability.card01.text[1].subtitle"
              ),
              subtext: this.$t(
                "product.VyungFCST.product_ability.card01.text[1].subtext"
              ),
            },
          ],
          contentImage: FCSTAbility01,
          numImage: numImage01,
        },
        {
          title: this.$t("product.VyungFCST.product_ability.card02.title"),
          text: [
            {
              subtitle: this.$t(
                "product.VyungFCST.product_ability.card02.text[0].subtitle"
              ),
              subtext: this.$t(
                "product.VyungFCST.product_ability.card02.text[0].subtext"
              ),
            },
            {
              subtitle: this.$t(
                "product.VyungFCST.product_ability.card02.text[1].subtitle"
              ),
              subtext: this.$t(
                "product.VyungFCST.product_ability.card02.text[1].subtext"
              ),
            },
          ],
          contentImage: FCSTAbility02,
          numImage: numImage02,
        },
        {
          title: this.$t("product.VyungFCST.product_ability.card03.title"),
          text: [
            {
              subtitle: this.$t(
                "product.VyungFCST.product_ability.card03.text[0].subtitle"
              ),
              subtext: this.$t(
                "product.VyungFCST.product_ability.card03.text[0].subtext"
              ),
            },
            {
              subtitle: this.$t(
                "product.VyungFCST.product_ability.card03.text[1].subtitle"
              ),
              subtext: this.$t(
                "product.VyungFCST.product_ability.card03.text[1].subtext"
              ),
            },
            {
              subtitle: this.$t(
                "product.VyungFCST.product_ability.card03.text[2].subtitle"
              ),
              subtext: this.$t(
                "product.VyungFCST.product_ability.card03.text[2].subtext"
              ),
            },
          ],
          contentImage: [FCSTAbility03, FCSTAbility04],
          numImage: numImage03,
        },
      ],

      //产品优势
      ProductSuperiorityData: [
        {
          title: this.$t("product.VyungFCST.product_advangtages.card01.title"),
          contentImage: FCST_icon01,
        },
        {
          title: this.$t("product.VyungFCST.product_advangtages.card02.title"),
          contentImage: FCST_icon02,
        },
      ],

      //产品案例
      ClassicCasesData: [
        {
          // imageBackground: HITACHIBackground,
          brandIcon: TCLIcon,
        },
        {
          // imageBackground: YTOBackground,
          brandIcon: PRINXIcon,
        },
        {
          // imageBackground: zhongtongBackground,
          brandIcon: JOHNIcon,
        },
      ],
    };
  },
  methods: {
 
  },
};
</script>